import { IApiResponse } from '@/contracts/core/api/interface/IApiResponse'

export class ApiResponse<T> implements IApiResponse<T>{
  private success: boolean
  private data: T | undefined
  private error: string | undefined
  private headers: Record<string, string>

  constructor(response: { success: boolean, data?: T, error?: string, headers?: Record<string, string> }) {
    this.success = response.success
    this.data = response.data
    this.error = response.error
    this.headers = {}
    for (const [name, value] of Object.entries(response.headers ?? {})) {
      this.headers[name.toLowerCase()] = value
    }
  }

  isSuccess(): boolean {
    return this.success
  }

  getData(): T {
    if (this.data === undefined) {
      throw new Error('Data is undefined')
    }

    return this.data
  }

  getHeader(name: string): string | null {
    return this.headers[name.toLowerCase()] ?? null
  }

  getError(): string {
    if (this.error === undefined) {
      throw new Error('Error is undefined')
    }

    return this.error
  }
}
